package es.subastia.domain.usecase

import es.subastia.domain.model.AuctionTypeDomainModel
import es.subastia.domain.model.ProvinceDomainModel
import es.subastia.domain.repository.UserRepository
import kotlinx.coroutines.flow.Flow

class GetUserPreferencesUseCase(private val repository: UserRepository) {
    fun getSavedType(): Flow<AuctionTypeDomainModel?> = repository.getSavedAuctionType()
    fun getSavedProcedureType(): Flow<es.subastia.domain.model.AuctionProcedureType?> = repository.getSavedAuctionProcedureType()
    fun getSavedProvince(): Flow<ProvinceDomainModel?> = repository.getSavedProvince()
}

class SaveUserPreferencesUseCase(private val repository: UserRepository) {
    suspend fun saveType(type: AuctionTypeDomainModel?) = repository.saveAuctionType(type)
    suspend fun saveProcedureType(type: es.subastia.domain.model.AuctionProcedureType?) = repository.saveAuctionProcedureType(type)
    suspend fun saveProvince(province: ProvinceDomainModel?) = repository.saveProvince(province)
}

